import { render, staticRenderFns } from "./MarketOrders.vue?vue&type=template&id=6ee7360c&scoped=true"
import script from "./MarketOrders.vue?vue&type=script&lang=js"
export * from "./MarketOrders.vue?vue&type=script&lang=js"
import style0 from "./MarketOrders.vue?vue&type=style&index=0&id=6ee7360c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7360c",
  null
  
)

export default component.exports